import { Currency } from "@redotech/money/currencies";

type CommonLoyaltyInfo = { pointsForPurchase: number };

export type LoggedOutLoyaltyInfo = CommonLoyaltyInfo & { loggedIn: false };

export type LoggedInLoyaltyInfo = CommonLoyaltyInfo & {
  loggedIn: true;
  customerId: string;
  customerName: string;
  pointsBalance: number;
  singlePointValue: { currency: Currency; amount: number };
  loyaltyDashboardUrl: string;
};

export type LoyaltyInfo = LoggedOutLoyaltyInfo | LoggedInLoyaltyInfo;

export function useLoyaltyInfo(): LoyaltyInfo {
  const loggedIn = unsafeIsLoggedInToStorefront();
  if (loggedIn.loggedIn) {
    return {
      loggedIn: true,
      customerId: loggedIn.customerId,
      customerName: "John Doe",
      pointsBalance: 100,
      singlePointValue: { currency: Currency.USD, amount: 0.01 },
      pointsForPurchase: 100,
      loyaltyDashboardUrl: "https://getredo.com/",
    };
  }

  return { loggedIn: false, pointsForPurchase: 100 };
}

function unsafeIsLoggedInToStorefront():
  | { loggedIn: false }
  | { loggedIn: true; customerId: string } {
  const customerId: string | undefined = (globalThis as any).ShopifyAnalytics
    ?.meta.page.customerId;
  if (!customerId) {
    return { loggedIn: false };
  }

  return { loggedIn: true, customerId };
}
